export default {
  GET_LOCATION_DATA: (state) => state.locationData,
};
